export default "__VITE_ASSET__BdHbe_J5__"